let authJson = {};
try {
    authJson = JSON.parse(window?.parent?.name);
} catch (e) {
    // ignore error
}
export const cmsAuth = authJson;
